// extracted by mini-css-extract-plugin
module.exports = {"main-component":"dfvIcon_main-component__2Aviu","dfv-tagline":"dfvIcon_dfv-tagline__1iWdq","dfvSubTag":"dfvIcon_dfvSubTag__3500g"};